import {
	useEmailScheduleConfig,
	useUpsertEmailScheduleConfig,
} from '@dealstack/frontend/app/pages/Project/MIP/hooks/useEmailScheduleConfig';
import { useTranslationMipManage } from '@dealstack/frontend/shared/mechanism/i18n/i18nHooks.tsx';
import { useParams } from 'react-router-dom';
import type { EmailScheduleConfigScope } from '@dealstack/frontend/app/pages/Project/MIP/hooks/useEmailScheduleConfig.types';
import { ConfigCard } from './ConfigCard';
import type { ConfigCardOnSave } from './ConfigCard.types';
import { ConfigurationTabContainer } from './styles';

interface Props {
	organizationId?: string;
}

export const ConfigurationTab = ({ organizationId }: Props) => {
	const tMipManage = useTranslationMipManage();
	const { dealId, mipId: programmeId } = useParams();

	const scope: EmailScheduleConfigScope = organizationId
		? { organizationId }
		: { dealId, programmeId };

	const { data: configs, isLoading } = useEmailScheduleConfig(scope);
	const { mutate, isPending } = useUpsertEmailScheduleConfig({ scope });

	const handleSave = (values: ConfigCardOnSave) => {
		mutate({
			...values,
			endDate: values.endDate ? values.endDate.toISOString() : null,
		});
	};

	if (isLoading) {
		return null;
	}

	if (!configs || configs.length === 0) {
		return (
			<ConfigurationTabContainer>
				{tMipManage('automated_emails.configuration.empty')}
			</ConfigurationTabContainer>
		);
	}

	return (
		<ConfigurationTabContainer>
			{configs.map((config) => (
				<ConfigCard
					key={config.type}
					config={config}
					onSave={handleSave}
					isSaving={isPending}
					showEndDate={!organizationId}
				/>
			))}
		</ConfigurationTabContainer>
	);
};
